import NextLink from 'next/link';

function isExternalHref(href: string): boolean {
  return /^(https?:|\/\/)/.test(href);
}

export function Link({
  href,
  children,
  ariaLabel,
  target = '_self',
}: {
  href: string;
  children: React.ReactNode;
  ariaLabel: string;
  target?: string;
}) {
  const isExternal = isExternalHref(href);
  const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
  const className = 'inlineLink';

  if (isExternal) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        className={className}
        aria-label={ariaLabel}
      >
        {children}
      </a>
    );
  }

  return (
    <NextLink
      href={href}
      target={target}
      rel={rel}
      className={className}
      aria-label={ariaLabel}
    >
      {children}
    </NextLink>
  );
}
